import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterObject } from '../filter-object';

@Component({
  selector: 'filter-checkbox',
  templateUrl: './filter-checkbox.component.html',
  styleUrls: ['./filter-checkbox.component.scss'],
})
export class FilterCheckboxComponent implements OnInit {
  @Input() public filterObject: FilterObject;
  @Input() public label: string;

  @Output() public toggleFilterEmitter: EventEmitter<string> =
    new EventEmitter<string>();
  @Output() public filterValueChanged: EventEmitter<FilterObject> =
    new EventEmitter<FilterObject>();

  constructor() {}

  ngOnInit() {}

  public onFilterValueChange(checked: boolean): void {
    this.filterObject.value = checked ? 'true' : 'false';
    this.filterObject.active = checked;
    this.filterValueChanged.emit(this.filterObject);
  }
}
